import 'es6-promise/auto'
import pinia from './pinia'

export default pinia
export { pinia }
export { useAppStore } from './app'
export { useBusinessStore } from './business'
export { useSessionStore } from './session'
export { useStageStore } from './stage'
export { useUiStore } from './ui'
export { useXdvideoStore } from './xdvideo'
